import {
  titreTexteMediaLpSimple1,
  titreTexteMediaLpSimple2,
  titreTexteMediaLpSimple3,
  titreTexteMediaLpSimple4,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [
  titreTexteMediaLpSimple1(),
  titreTexteMediaLpSimple2(),
  titreTexteMediaLpSimple3(),
  titreTexteMediaLpSimple4(),
];

export const lpSimpleMock: SlugPage = {
  ...pageBase({
    title: 'LP Simple',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
